export default "__VITE_ASSET__gKoGYwbx__"